module.exports = __webpack_public_path__ + "img/1.34ad2a03.jpg";